import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f1b6e02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-container" }
const _hoisted_2 = {
  ref: "calendarWrapper",
  class: "calendar-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, [
  /*#__PURE__*/_createTextVNode(" 선택하신 일자는 좌석이 없습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("예약대기 하시겠습니까? ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      class: "navigation-bar",
      title: $setup.getTitle(),
      shouldHideBackButton: true,
      shouldShowUnderline: true,
      onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickClose')))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      ($props.bookableDatesInfos.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.bookableDatesInfos, (bookableDatesInfo) => {
            return (_openBlock(), _createBlock($setup["MonthlyBookCalendarWithDuplicatedSeat"], {
              key: bookableDatesInfo.bookableMonth,
              bookableDatesInfo: bookableDatesInfo,
              selectedDateInfo: $setup.selectedDateInfo,
              isMonthlyBook: $props.isMonthlyBook,
              seatsSelectable: $setup.seatsSelectable,
              allowWaitList: $setup.allowWaitList,
              onOnClickDay: $setup.onClickDay,
              onOnClickDayForWaiting: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowWaitingConfirmModal(true))),
              onOnUpdateBookingDate: $setup.updateBookingDate,
              onOnRemoveBookingDate: $setup.removeBookingDate
            }, null, 8 /* PROPS */, ["bookableDatesInfo", "selectedDateInfo", "isMonthlyBook", "seatsSelectable", "allowWaitList"]))
          }), 128 /* KEYED_FRAGMENT */))
        : (_openBlock(), _createBlock($setup["EmptyContent"], {
            key: 1,
            class: "empty-content",
            text: "예약가능한 일자가 없습니다"
          }))
    ], 512 /* NEED_PATCH */),
    _createVNode($setup["SeatAndPaymentForDuplicatedSeat"], {
      turnId: $props.turnId,
      getOnBusStopId: $props.getOnBusStopId,
      getOffBusStopId: $props.getOffBusStopId,
      bookingDates: $setup.bookingDates,
      realBookableDatesLength: $setup.realBookableDatesLength,
      selectedDateInfo: $setup.selectedDateInfo,
      duplicateSeatNo: $setup.duplicateSeatNo,
      oneTimeFare: $setup.oneTimeFare,
      totalAmount: $setup.totalAmount,
      seatsSelectable: $setup.seatsSelectable,
      onOnClickSeat: $setup.onClickSeat,
      onOnChangedFooterHeight: $setup.updateFooterWrapperHeight,
      onOnFetchedSeatLayout: $setup.updateSeatNo
    }, null, 8 /* PROPS */, ["turnId", "getOnBusStopId", "getOffBusStopId", "bookingDates", "realBookableDatesLength", "selectedDateInfo", "duplicateSeatNo", "oneTimeFare", "totalAmount", "seatsSelectable"]),
    ($setup.showWaitingConfirm)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          title: "예약대기 알림신청",
          cancelButtonTitle: "취소",
          onOnClickCancelButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowWaitingConfirmModal(false))),
          okButtonTitle: "예약대기",
          onOnClickOkButton: $setup.registerWaitingList
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}